export const APPEARANCE_IMAGE_MAX_BYTES = 1024 * 1024;
export const APPEARANCE_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
export const DEFAULT_APPEARANCE_COLOR = '#FFFFFF';
